import { render } from "./Admin.vue?vue&type=template&id=4d117f32&scoped=true&ts=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"

import "./Admin.vue?vue&type=style&index=0&id=4d117f32&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d117f32"]])

export default __exports__